import { label, labelSecondary } from 'styles'

import { makeStyles } from '@mui/styles'

export default makeStyles({
  description: {
    backgroundColor: labelSecondary,
    borderBottom: `1px solid ${label}`,
    fontSize: '1.2rem',
    fontWeight: '700',
    padding: '0.8rem',
    textAlign: 'center',
  },
  footer: {
    backgroundColor: labelSecondary,
    borderBottom: `1px solid ${label}`,
    fontWeight: '700',
  },
  footerCell: {
    alignSelf: 'center',
    display: 'flex',
    fontWeight: '700',
    padding: '0.8rem',
  },
  header: {
    backgroundColor: labelSecondary,
    fontWeight: '700',
    padding: '0.8rem',
    textAlign: 'center',
  },
  origin: {
    '&&': {
      paddingLeft: '1.6rem',
    },
    alignItems: 'center',
    display: 'flex',
    height: '100%',
  },
  percent: {
    '& .info_percent-difference': {
      color: label,
      fontWeight: '400' as 'normal',
    },
    fontSize: '1rem',
  },
  sum: {
    '&&': {
      fontWeight: '700',
      paddingRight: '1.6rem',
    },
  },
  value: {
    alignItems: 'center',
    display: 'flex',
    fontSize: '1rem',
    fontWeight: '400' as 'normal',
    padding: '0.8rem',
  },
  wrapper: {
    textAlign: 'initial',
  },
})
